import * as React from 'react';

import { useAuth } from './auth-context';
import type { Can } from './permissions';

/**
 * `can(permission)` for the signed-in account — survey-api's effective permissions as `/auth/me`
 * last sent them (SR-228), and nothing else: no role code, role name or kind is tested here, and
 * nothing is derived from the deprecated `role` (the role-model UI design's R1).
 *
 * Like `AdminRoute`, it decides what renders and nothing more — a section hidden, a control
 * disabled. survey-api reads the permissions afresh on every request (its D4), so what this
 * answers can be a read behind; the forbidden handler and `TeamShell`'s re-read on a shown tab
 * are what bring it level, and every guard re-renders from the new answer.
 *
 * No user answers `false` for everything: a guard drawn before `/auth/me` lands opens nothing.
 */
export function useCan(): Can {
  const { user } = useAuth();
  const held = user?.permissions;
  return React.useCallback<Can>((permission) => !!held && held.includes(permission), [held]);
}
